app.component("surgicalGoals", {
	templateUrl: "app/src/js/components/operationNote/eyeBank/commonComponents/surgicalGoals/surgicalGoals.html",
	controller: "surgicalGoalsController",
	bindings: {
		data: "<",
		eyeTitle: "@",
	},
});

app.controller("surgicalGoalsController", [
	"$scope",
	function ($scope) {
		$scope.options = [
			{ name: "Pain Relief", model: "is_pain_relief"},
			{ name: "Improved Visual Acuity", model: "is_improved_visual_acuity" },
			{ name: "Tectonic/Structural Repair", model: "is_tectonic_structural_repair" },
			{ name: "Cosmesis", model: "is_cosmesis" },
		];

		this.$onInit = function () {};

        $scope.isRequired = () => {
			return (
				!$scope.$ctrl.data.surgical_goals.is_pain_relief &&
				!$scope.$ctrl.data.surgical_goals.is_improved_visual_acuity &&
				!$scope.$ctrl.data.surgical_goals.is_tectonic_structural_repair &&
				!$scope.$ctrl.data.surgical_goals.is_cosmesis
			);
		};
	},
]);